import { render, staticRenderFns } from "./verReclamoLeechero.vue?vue&type=template&id=d779fb94&scoped=true&"
import script from "./verReclamoLeechero.vue?vue&type=script&lang=js&"
export * from "./verReclamoLeechero.vue?vue&type=script&lang=js&"
import style0 from "./verReclamoLeechero.vue?vue&type=style&index=0&id=d779fb94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d779fb94",
  null
  
)

export default component.exports